export default __webpack_public_path__ + "static/media/erythree_carte_3-min.1b5ebf2b.png";